import { type ScoreTier } from '../../process/creative-process.types'

/** Theme-aware CSS color for a score tier (used inline for ring/number/bars). */
export function tierColor(tier: ScoreTier): string {
  switch (tier) {
    case 'strong':
      return 'var(--success)'
    case 'solid':
      return 'var(--acid)'
    default:
      return 'var(--destructive-bright, var(--destructive))'
  }
}
